import { api } from './client'

export interface ConstantOption {
  value: string
  label: string
  description?: string
}

export interface Constants {
  status: ConstantOption[]
  supply_types: ConstantOption[]
  demand_types: ConstantOption[]
  ad_formats: ConstantOption[]
  device_types: ConstantOption[]
  protocols: ConstantOption[]
  openrtb_versions: ConstantOption[]
  endpoint_status: ConstantOption[]
  cluster_status: ConstantOption[]
  regions: ConstantOption[]
  auction_types: ConstantOption[]
  http_methods: ConstantOption[]
  content_types: ConstantOption[]
  auth_types: ConstantOption[]
  safety_levels: ConstantOption[]
  currencies: ConstantOption[]
  countries: ConstantOption[]
  video_placements: ConstantOption[]
  banner_sizes: ConstantOption[]
  connection_types: ConstantOption[]
  api_frameworks: ConstantOption[]
  iab_categories: ConstantOption[]
  creative_attributes: ConstantOption[]
  operating_systems: ConstantOption[]
  browsers: ConstantOption[]
  languages: ConstantOption[]
  // Privacy & Compliance
  tcf_versions: ConstantOption[]
  consent_defaults: ConstantOption[]
  gpp_sections: ConstantOption[]
  us_privacy_states: ConstantOption[]
  gdpr_countries: ConstantOption[]
  data_retention_periods: ConstantOption[]
  // Deal Management
  deal_types: ConstantOption[]
  deal_status: ConstantOption[]
  pacing_types: ConstantOption[]
  frequency_periods: ConstantOption[]
  timezones: ConstantOption[]
  days_of_week: ConstantOption[]
  payment_terms: ConstantOption[]
  // Billing (OpenRTB 2.5/2.6)
  billing_types: ConstantOption[]
  // User Sync (Cookie Mapping)
  sync_types: ConstantOption[]
  // Inventory (OpenRTB)
  inventory_types: ConstantOption[]
  inventory_platforms: ConstantOption[]
  verification_methods: ConstantOption[]
}

export async function getConstants(): Promise<Constants> {
  // API client interceptor already unwraps the response data
  return api.get<Constants>('/constants')
}

export async function getConstantGroup(group: keyof Constants): Promise<ConstantOption[]> {
  // API client interceptor already unwraps the response data
  return api.get<ConstantOption[]>(`/constants?group=${group}`)
}
